import React, { Component } from "react";
import Product from "./Product";
import Title from "./Title";
import moment from 'moment';
import { Table, Badge} from 'reactstrap';
import styled from "styled-components";
import { ProductConsumer } from "../context";
import firebase from "./Fireb"
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button'
import {Text } from 'react-native'
//import { storeProducts } from "../data";

export default class paymentl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendorPay: [],
        key: '',
        check: false
    };
    
  }



  componentDidMount() {
    const vendorPay =[];
    const ref = firebase.firestore().collection('vendorPay').where("vendoruid", "==", firebase.auth().currentUser.uid).orderBy("timestamp", "desc");
    ref.get().then((querySnapshot => {
      querySnapshot.forEach((doc) => {
        const { vname, tno, status, Bill, day } = doc.data();
        vendorPay.push({
          key: doc.id,
          doc, // DocumentSnapshot
          vname,
          tno,
          status,
          Bill,
          day
        })})  
      this.setState({ vendorPay});
    }));
    const ref2 = firebase.firestore().collection('vendorPay').where("vendoruid", "==", firebase.auth().currentUser.uid);
    ref2.get().then((querySnapshot => {
      querySnapshot.forEach((doc) => {
      if (doc.exists) {
        this.setState({
          check: true
        })
      } else {
        this.setState({
          check: false
        })
      }
    });
  }))
  
  
  }

  
  rendercheck() {
    if(this.state.check == true) {
    return (
      <React.Fragment>
        <ProductWrapper className="py-5">
          <div className="container">
            <Title name="Payment" title="List" />
            <Table striped hover>
            <table class="table" >
              <thead>
                <tr class="table">
                  <th>Index</th>
                  <th>Shop Name</th>
                  <th>Transaction Numbers</th>
                  <th>Bill</th>
                  <th>Date</th>
                  <th>Billing Status</th>
                

                
                </tr>
              </thead>
              <tbody>
                {this.state.vendorPay.map((vendorPay, i ) =>
                  <tr>
                  <td>{i+=1}</td>
                  <td>{vendorPay.vname}</td>
                  <td>{vendorPay.tno}</td>
                  <td>{vendorPay.Bill}<Text style={{color: "green", fontWeight: "800", fontSize: 10}}>Rs.</Text></td>
                  <td>{vendorPay.day}</td>
                <td> {vendorPay.status == "Paid" ? <Badge color="success" pill>{vendorPay.status}</Badge> : <Badge color="warning" pill>{vendorPay.status}</Badge>}</td>
                <td>{vendorPay.status == "Pending"
    ?  <Button style={{background: "grey",
    color: "black",
    fontSize: "14px",
    cursor: "pointer",
    padding: "10px",
    margin: "5px",}} disabled> View Reciept </Button>
                : <Link to={`/Reciept/${vendorPay.key}`}><Button style={{backgroundImage: "linear-gradient(to left, #000428 , #004e92)",
                color: "white",
                fontSize: "14px",
                cursor: "pointer",
                padding: "10px",
                margin: "5px"}} onClick={this.overdraft}> View Reciept </Button></Link>}</td>          
                </tr>
              )}
            </tbody>
          </table>
          </Table>
 
          </div>
        </ProductWrapper>
      </React.Fragment>
    );
                }
  }
  rendercheck2()
  { 
    
    if(this.state.check == false) {
   
    return(
      <div className="container">
      <Title name="You don't have" title="any payment list right now" />
      </div>
    )}
  
  }
  render() {
  
    return (
     <div>
    {this.rendercheck()}
    
    {this.rendercheck2()}
    
        </div>
    )
  }
  
}

const ProductWrapper = styled.section``;